import React, { useMemo } from "react";
import DropdownRow from "../../DropdownRow";
import { WorkRequestSelectWorkTypeDropdownProps } from "../types";
import { WorkType } from "src/types";

const WorkRequestSelectWorkTypeDropdown = ({
  isVerifyMode,
  setFormData,
  workTypes,
}: WorkRequestSelectWorkTypeDropdownProps) => {
  const getWorkTypePriority = (workType: WorkType) => {
    const priorityValue = workType.priority ?? workType.sortOrder ?? workType.sortorder;

    return typeof priorityValue === "number" ? priorityValue : Number.MAX_SAFE_INTEGER;
  };

  const dropdownWorkTypes = useMemo(
    () =>
      [...workTypes]
        .sort((firstWorkType, secondWorkType) => {
          const firstPriority = getWorkTypePriority(firstWorkType);
          const secondPriority = getWorkTypePriority(secondWorkType);

          if (firstPriority !== secondPriority) {
            return firstPriority - secondPriority;
          }

          return firstWorkType.name.localeCompare(secondWorkType.name);
        })
        .map((workType: WorkType) => {
          return {
            id: workType.id,
            value: workType.name,
            type: workType.type,
          };
        }),
    [workTypes],
  );
  return (
    <DropdownRow
      disabled={isVerifyMode}
      label="Work Type:"
      dropdownItems={dropdownWorkTypes}
      placeholder={"Select Work Type"}
      onClick={(item) => setFormData((data) => ({ ...data, workType: item.type }))}
    />
  );
};

export default WorkRequestSelectWorkTypeDropdown;
